import React from 'react';
import { LeaseCreatorFormItem } from '../common/LeaseCreatorFormItem';
import { FormError } from '../common/FormError';
import { MoneyInput } from '../common/MoneyInput';

import { Formik } from 'formik';

import * as Yup from 'yup';

import Col from 'components/ui/Col';
import { VerticalFormWrapper } from 'components/ui/VerticalFormWrapper';

import isEmpty from 'lodash/isEmpty';

import { getTranslatedString } from 'helpers/i18n';

import styled from 'styled-components';

import Row from 'components/ui/Row';

import { AntdSelect as Select, AntdButton as Button } from '@yuhuinc/ui-library/';
import { StyledButton } from '../common/LeaseStyles';
import { responsive } from 'helpers/StyleHelper';

const StyledRow = styled(Row)`
  margin-bottom: ${(props) => props.mb || '21px'};
  margin-top: ${(props) => props.mt || '0px'};
`;

const SyledFormButtonContainer = styled.div`
  display: flex;
`;

const AdditionalChargeForm = ({
  setToggleNewItem,
  getAdditionalCharges,
  validAdditionalCharges,
  getAdditionalChargeName,
  getAdditionalChargeAmount,
  setValidAdditionalChargesInStore,
  currentEditableItem,
  resetAfterEdit,
  isEdit,
  editIndex,
  isMobile,
}) => {
  const labelSize = isMobile ? responsive.text.mobile : responsive.text.desktop;

  return (
    <Formik
      initialValues={{
        charge_name_by_id: currentEditableItem.id || undefined,
        charge_value: currentEditableItem.default_amount || undefined,
      }}
      validationSchema={Yup.object().shape({
        charge_name_by_id: Yup.string().required(
          getTranslatedString(
            'landlordPortal.leaseCreatorV2.leasePricingPage.additionalChargeNameRequired'
          )
        ),
        charge_value: Yup.number().required(
          getTranslatedString(
            'landlordPortal.leaseCreatorV2.leasePricingPage.additionalChargeAmountRequired'
          )
        ),
      })}
      onSubmit={(values) => {
        const newValidAdditionalCharges = [...validAdditionalCharges];
        const name = getAdditionalChargeName(values.charge_name_by_id);

        if (isEdit) {
          newValidAdditionalCharges[editIndex] = {
            id: values.charge_name_by_id,
            name,
            default_amount: values.charge_value,
          };
          resetAfterEdit();
        } else {
          newValidAdditionalCharges.push({
            id: values.charge_name_by_id,
            name,
            default_amount: values.charge_value,
          });
        }
        setValidAdditionalChargesInStore(newValidAdditionalCharges);
        setToggleNewItem(false);
      }}
    >
      {({ handleSubmit, values, setFieldValue, setFieldTouched, errors, touched }) => {
        let additionalChargesOptions = getAdditionalCharges();

        const handleCancelItem = () => {
          resetAfterEdit();
          setToggleNewItem(false);
        };

        return (
          <VerticalFormWrapper id="ADDITIONAL_CHARGE_FORM" onSubmit={handleSubmit}>
            {!isEmpty(errors) && (
              <StyledRow>
                <FormError errors={errors} />
              </StyledRow>
            )}

            <StyledRow gutter={16} mb="16px">
              <Col md={12}>
                <LeaseCreatorFormItem label="Item" labelSize={labelSize} required>
                  <Select
                    id="charge_name_by_id"
                    name="charge_name_by_id"
                    placeholder="Select an item"
                    optionData={additionalChargesOptions}
                    handleChange={(value) => {
                      const amount = getAdditionalChargeAmount(value);
                      setFieldValue('charge_name_by_id', value);
                      setFieldValue('charge_value', amount);
                    }}
                    value={
                      getAdditionalChargeName(values.charge_name_by_id) ||
                      values['charge_name_by_id']
                    }
                    error={touched.charge_name_by_id && errors.charge_name_by_id}
                    isMobile={isMobile}
                  />
                </LeaseCreatorFormItem>
              </Col>
              <Col md={12}>
                <LeaseCreatorFormItem label="Value" labelSize={labelSize} required>
                  <MoneyInput
                    id="charge_value"
                    name="charge_value"
                    value={values['charge_value']}
                    handleChange={(value) => {
                      setFieldTouched('charge_value');
                      if (value === '' || value === null) {
                        setFieldValue('charge_value', undefined);
                      } else {
                        setFieldValue('charge_value', value);
                      }
                    }}
                    error={touched.charge_value && errors.charge_value}
                    isMobile={isMobile}
                  />
                </LeaseCreatorFormItem>
              </Col>
            </StyledRow>

            <SyledFormButtonContainer>
              <StyledButton
                label={getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.cancel')}
                htmlType="button"
                onClick={handleCancelItem}
                size={isMobile ? 'large' : 'default'}
              />
              <Button
                type="primary"
                htmlType="submit"
                form="ADDITIONAL_CHARGE_FORM"
                label={
                  isEdit
                    ? getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.update')
                    : getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.add')
                }
                size={isMobile ? 'large' : 'default'}
              />
            </SyledFormButtonContainer>
          </VerticalFormWrapper>
        );
      }}
    </Formik>
  );
};

export { AdditionalChargeForm };
